export const SET_PLUGINS = 'dashboard/integrations/set-plugins';
export const SET_APIS = 'dashboard/integrations/set-apis';
export const SET_PAGE_STATUS = 'dashboard/pageStatus/set-page-status';
